"use client";

import { useAcceptTerms, usePrivy } from "@privy-io/react-auth";
import { FileCheck2Icon } from "lucide-react";
import { useState } from "react";
import { Button, Modal } from "ui/components";

export function AcceptTermsModal() {
  const { ready, authenticated, user, logout } = usePrivy();
  const { acceptTerms } = useAcceptTerms();
  const [isAccepting, setIsAccepting] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);

  const isOpen = ready && authenticated && !!user && !user.hasAcceptedTerms;

  async function handleAccept() {
    setIsAccepting(true);
    try {
      await acceptTerms();
    } finally {
      setIsAccepting(false);
    }
  }

  async function handleDecline() {
    setIsDeclining(true);
    try {
      await logout();
    } finally {
      setIsDeclining(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      showCloseButton={false}
      className="sm:min-w-0 sm:w-100 px-8 py-10 items-center text-center rounded-2xl"
    >
      <div className="flex flex-col items-center gap-6">
        <div className="flex size-16 items-center justify-center rounded-full bg-ref-earth-50">
          <FileCheck2Icon className="size-7 text-ref-earth-400" />
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-medium text-text-primary">One last step</h2>
          <p className="text-sm text-text-secondary">
            By signing up, you agree to our terms and privacy policy.
          </p>
        </div>

        <a
          href="https://docs.usd.ai/terms-of-service/usd.ai-terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full items-center justify-between rounded-lg border border-outline-major bg-ref-earth-50/50 px-4 py-3 text-sm text-text-primary hover:bg-ref-earth-50 transition-colors"
        >
          <span>View Terms</span>
          <svg className="size-4 text-text-secondary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" />
          </svg>
        </a>

        <div className="flex w-full flex-col gap-3">
          <Button
            className="btn-primary w-full py-3 rounded-lg"
            isLoading={isAccepting}
            onClick={handleAccept}
          >
            Accept
          </Button>
          <Button
            className="btn-tertiary w-full py-3 rounded-lg border border-outline-major"
            isLoading={isDeclining}
            onClick={handleDecline}
          >
            No thanks
          </Button>
        </div>
      </div>
    </Modal>
  );
}
